const issuesServiceTypes = [
  { value: "LEAK", label: "FUGA" },
  { value: "COMPLAINT", label: "QUEJA" },
  { value: "OTHER", label: "OTRO" }
]

const issuesStatus = [
  { value: "ACTIVE", label: "ACTIVO" },
  { value: "ASSIGNED", label: "ASIGNADO" },
  { value: "RESOLVED", label: "RESUELTO" },
  { value: "CANCELED", label: "CANCELADO" }
]

export const initialValues = {
  values: {
    issueId: null,
    statusOpt: issuesStatus,
    unitsOpt: [],
    serviceTypesOpt: issuesServiceTypes,
    idStation: null,
    idUnit: null,
    service: null,
    accountCode: null,
    serviceType: null,
    status: null,
    technician: null,
    observations: null,
    isFinshed: false
  },
  required: {
    idStation: { required: true },
    service: { required: false },
    accountCode: { required: true },
    serviceType: { required: true },
    status: { required: true },
    technician: { required: false },
    observations: { required: true }
  }
}